import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { WatchStopHandle, onMounted, onUnmounted, ref, watch } from 'vue'

import {
  cloneReactiveToRaw,
  deepToRaw,
  envOverrides,
  MicroFrontendLogger,
} from '@sennder/shell-utilities'

import { createRandomString } from '../utils'
import {
  getStateData,
  getStateCallbacks,
  getStateProviders,
} from '@/store/getters'
import { getMicrofrontendData } from '@/store'
import { logger } from '@/services/logger/loggers'
import { loggerInstance } from '@/services/logger'
import { AppAnalyticsProvider } from '@/services/analyticsProvider'
import { isLocalEnv } from '@/common/config'
import { microfrontends } from '@/config/microfrontends'


export default /*#__PURE__*/_defineComponent({
  __name: 'AcceleratedPaymentMF',
  setup(__props) {

const mf = microfrontends.acceleratedPayment
const mountId = createRandomString()
const containerId = `${mountId}-accelerated-payment`
const containerRef = ref(null)
const unmount = ref<(() => void) | null>(null)
let watchHandles: WatchStopHandle[] = []

onMounted(async () => {
  try {
    const runHotEnv = isLocalEnv() && envOverrides.isHot(mf.npmName)
    const mount = (
      await mf.getModule<any>(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        mf.mountExposedName!,
        runHotEnv ? 'hot' : undefined
      )
    )?.mount

    if (!mount) {
      throw new Error('cannot load mount function for accelerated payment mF')
    }

    if (!containerRef.value) {
      console.debug(`🚫 will not mount accelerated payment (${mountId})`)
      return
    }

    const data = deepToRaw(await getMicrofrontendData(mf.npmName))
    const analytics = new AppAnalyticsProvider({
      module: mf.npmName,
      submodule: mf.npmName,
    })

    const mfData = mount(`#${containerId}`, {
      data,
      callbacks: getStateCallbacks(),
      providers: {
        ...getStateProviders(),
        logger: new MicroFrontendLogger(
          { module: mf.npmName, codeOwners: '' },
          () => loggerInstance
        ),
        analytics,
      },
    })

    if (mfData.onSharedDataChanged) {
      watchHandles.push(
        watch(
          () => getStateData(),
          (updatedData) => {
            mfData.onSharedDataChanged(cloneReactiveToRaw(updatedData))
          },
          { deep: true }
        )
      )
    }

    if (mfData.unmount) {
      unmount.value = mfData.unmount
    }

    console.debug(`📥 mounted accelerated payment (${mountId})`)
  } catch (error) {
    logger.error('[µ-frontend accelerated payment bootstrap error]', { error })
  }
})

onUnmounted(() => {
  if (unmount.value) {
    unmount.value()
  }
  if (watchHandles.length) {
    for (const unwatch of watchHandles) {
      unwatch()
    }
    watchHandles = []
  }
  console.debug(`🗑️ unmounted accelerated payment (${mountId})`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: containerId,
    ref_key: "containerRef",
    ref: containerRef
  }, null, 512 /* NEED_PATCH */))
}
}

})